import React from "react";

export default function PortfolioIntroStatCard({ icon, value, label, theme }) {
  return (
    <div className="border rounded-3 p-3 h-100 portfolio-intro-stat-card">
      <div className="d-flex align-items-center">
        {/* 다크/라이트 테마와 일관되게 보이도록 차트 컬러 토큰을 아이콘 배경에 재사용한다. */}
        <div
          className="rounded-circle d-flex align-items-center justify-content-center me-3"
          style={{
            width: "52px",
            height: "52px",
            backgroundColor: theme.dataFill,
            color: theme.dataLine,
          }}
        >
          <i className={`${icon} fs-4`}></i>
        </div>
        <div>
          <div className="portfolio-intro-stat-value">{value}</div>
          <div className="portfolio-intro-stat-label">{label}</div>
        </div>
      </div>
    </div>
  );
}
